export function createType(namespace, type) {
  return `platfi-ui-app/${namespace}/${type}`;
}

export function createActionCreator(type, ...argNames) {
  return (...args) =>
    argNames.reduce(
      (acc, arg, index) => {
        acc[arg] = args[index];
        return acc;
      },
      { type },
    );
}

export function createReducer(initialState, handlers) {
  return (state = initialState, action) =>
    Object.prototype.hasOwnProperty.call(handlers, action.type)
      ? handlers[action.type](state, action)
      : state;
}

export function combineReducerArray(initialState, reducers) {
  return (state = initialState, action) =>
    reducers.reduce(
      (acc, reducer) =>
        Object.prototype.hasOwnProperty.call(reducer, action.type)
          ? reducer[action.type](acc, action)
          : acc,
      state,
    );
}
